// extracted by mini-css-extract-plugin
export default {"l":"_1c474410c4"};